import {
  PersonAdd as AddUserIcon,
  Login as LoginIcon,
  Settings,
  GridView as UserGridIcon,
} from "@mui/icons-material";

import HomeIcon from '@mui/icons-material/Home';
import ChurchIcon from '@mui/icons-material/Church';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChecklistIcon from '@mui/icons-material/Checklist';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import EditIcon from '@mui/icons-material/Edit';
import BarChartIcon from '@mui/icons-material/BarChart';
import DescriptionIcon from '@mui/icons-material/Description';
import GetAppIcon from '@mui/icons-material/GetApp';
import PaymentsIcon from '@mui/icons-material/Payments';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import SecurityIcon from '@mui/icons-material/Security';
import HistoryIcon from '@mui/icons-material/History';
import GroupsIcon from "@mui/icons-material/Groups";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ReceiptIcon from '@mui/icons-material/Receipt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AssessmentIcon from "@mui/icons-material/Assessment";
import ExploreIcon from '@mui/icons-material/Explore';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

// eslint-disable-next-line import/no-anonymous-default-export
export default {  
  HomeIcon,
  ChurchIcon,
  PersonIcon,
  SchoolIcon,
  HomeWorkIcon,
  EventAvailableIcon,
  AssessmentIcon,
  AssignmentIcon,
  ChecklistIcon,
  MenuBookIcon,
  HelpOutlineIcon,
  FactCheckIcon,
  LibraryBooksOutlinedIcon,
  EditIcon,
  BarChartIcon,
  DescriptionIcon,
  GetAppIcon,
  PaymentsIcon,
  SettingsIcon,
  PeopleIcon,
  SecurityIcon,
  HistoryIcon,
  GroupsIcon,
  GroupAddIcon,
  LoginIcon,
  AddUserIcon,
  Settings,
  ReceiptIcon,
  TrendingUpIcon,
  FolderSharedIcon,
  LibraryBooksIcon,
  ExploreIcon,
  AccountBalanceIcon,
  SubscriptionsIcon,
};


